import { styled } from "@mui/material";

const GAP_SPACING = 4;

export const StaticWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(GAP_SPACING),
}));

export const SpinnerWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  paddingTop: theme.spacing(GAP_SPACING),
}));

export const VirtualWrapper = styled("div")(({ theme }) => ({
  // offset the padding of the first item
  marginTop: theme.spacing(-GAP_SPACING),
}));
